<template>
  <div id="adminSelenaDashboard">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">Dashboard</li>
    </ol>
    <div class="container-fluid">
      <div class="row">
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-people bg-success p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-success">{{usersCount}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{users}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-chemistry bg-primary p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-primary">{{itemsCount}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">{{items}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-notebook bg-danger p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-danger">{{itemsNotConfiguredCount}}</div>
                <div class="text-muted text-uppercase font-weight-bold small">Categorie</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-directions bg-warning p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-warning">20/11/2019 08:00:01</div>
                <div class="text-muted text-uppercase font-weight-bold small">Ultima sincronizzazione</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-lg-4">
          <div class="card">
            <graphic :configurations="configurationsLanguage[1]" />
          </div>
        </div>
        <div class="col-sm-4 col-lg-4">
          <div class="card">
            <graphic :configurations="configurationsLanguage[2]" />
          </div>
        </div>
        <div class="col-sm-4 col-lg-4">
          <div class="card">
            <graphic :configurations="configurationsLanguage[5]" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-lg-4">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-people bg-success p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-success">+ 10</div>
                <div class="text-muted text-uppercase font-weight-bold small">Clienti in più dal mese passato</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-4">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-chemistry bg-primary p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-primary">+ 2</div>
                <div class="text-muted text-uppercase font-weight-bold small">Articoli in più dal mese passato</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-4">
          <div class="card">
            <div class="card-body p-3 d-flex align-items-center">
              <i class="icon-notebook bg-danger p-3 font-2xl mr-3"></i>
              <div>
                <div class="text-value-sm text-danger">+ 50</div>
                <div class="text-muted text-uppercase font-weight-bold small">Ordini ricevuti in più dal mese passato</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 col-lg-6">
          <div class="card">
            <graphic :configurations="configurationsLanguage[3]" />
          </div>
        </div>
        <div class="col-sm-6 col-lg-6">
          <div class="card">
            <graphic :configurations="configurationsLanguage[4]" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Graphic from "@/components/Graphic.vue";

export default {
  name: "adminSelenaDashboard",
  components: {
    Graphic
  },
  data: function() {
    return {
      configurationsLanguage: { 1: {}, 2: {}, 3: {}, 4: {}, 5: {} },
      items: dictionaryHelpers.getDictionary("Items"),
      itemsCount: 0,
      itemsNotConfigured: dictionaryHelpers.getDictionary("ItemsNotConfigured"),
      itemsNotConfiguredCount: 0,
      lastSync: dictionaryHelpers.getDictionary("LastSync"),
      lastSyncDate: "",
      users: dictionaryHelpers.getDictionary("Users"),
      usersCount: 0
    };
  },
  created() {
    var configurations = this;


    configurations.configurationsLanguage[1] = {
      title: "Ordini",
      idCont: "chart_1",
      confGrafic: {
        type: "bar",
        //data: itsResult.data,
        data: {
          labels: ["9/2019", "10/2019", "11/2019"],
          datasets: [
            {
              backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f"],
              data: [2478,5267,734]
            }
          ]
        },
        options: {
          legend: { display: false },
          animation: {
            animateRotate: false,
            animateScale: true,
            //easing: 'easeInOutElastic'
          },
          scales: {
            xAxes: [{
              gridLines: {
                display:false
              },
              ticks: {
                display: false //this will remove only the label
              }
            }],
            yAxes: [{
              gridLines: {
                display:false
              },
              ticks: {
                display: false //this will remove only the label
              }
            }]
          }
        }
      }
    };


    configurations.configurationsLanguage[2] = {
      title: "Top Clienti",
      idCont: "chart_2",
      confGrafic: {
        type: "pie",
        //data: itsResult.data,
        data: {
          labels: ["John", "Peter", "Maria"],
          datasets: [{
            backgroundColor: ["#3cba9f","#e8c3b9","#c45850"],
            data: [734,784,433]
          }]
        },
        options: {
          legend: {
            display: false
          },
          animation: {
            animateRotate: false,
            animateScale: true,
            //easing: 'easeInOutElastic'
          }
        }
      }
    };

    configurations.configurationsLanguage[3] = {
      title: "Ordini per ora del giorno",
      idCont: "chart_3",
      confGrafic: {
        type: "line",
        //data: itsResult.data,
        data:{
          labels: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
          datasets: [{
            data: [102,114,106,106,107,111,133,221,783,223,340,347,453,789,1762,237,356,736,803,568,589,674,236,102],
            borderColor: "#3e95cd",
            backgroundColor: "rgba(62,149,205,0.4)",
            fill: true
          }]
        },
        options: {
          legend: { display: false },
          animation: {
            animateRotate: false,
            animateScale: true,
            //easing: 'easeInOutElastic'
          },
          scales: {
            xAxes: [{
              gridLines: {
                display:false
              },
              ticks: {
                display: false //this will remove only the label
              }
            }],
            yAxes: [{
              gridLines: {
                display:false
              },
              ticks: {
                display: false //this will remove only the label
              }
            }]
          }
        }
      }
    };


    configurations.configurationsLanguage[4] = {
      title: "Importo per ora del giorno",
      idCont: "chart_4",
      confGrafic: {
        type: "line",
        //data: itsResult.data,
        data:{
          labels: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
          datasets: [{
            data: [102,114,106,106,107,111,133,221,783,223,340,347,453,789,1762,237,356,736,803,568,589,674,236,102],
            borderColor: "#3e95cd",
            backgroundColor: "rgba(62,149,205,0.4)",
            fill: true
          }]
        },
        options: {
          legend: { display: false },
          animation: {
            animateRotate: false,
            animateScale: true,
            //easing: 'easeInOutElastic'
          },
          scales: {
            xAxes: [{
              gridLines: {
                display:false
              },
              ticks: {
                display: false //this will remove only the label
              }
            }],
            yAxes: [{
              gridLines: {
                display:false
              },
              ticks: {
                display: false //this will remove only the label
              }
            }]
          }
        }
      }
    };


    configurations.configurationsLanguage[5] = {
      title: "Top Ordini",
      idCont: "chart_5",
      confGrafic: {
        type: "pie",
        //data: itsResult.data,
        data: {
          labels: ["John", "Peter", "Maria"],
          datasets: [{
            backgroundColor: ["#3cba9f","#e8c3b9","#c45850"],
            data: [100,205,6954]
          }]
        },
        options: {
          legend: {
            display: false
          },
          animation: {
            animateRotate: false,
            animateScale: true,
          //  easing: 'easeInOutElastic'
          }
        }
      }
    };


    userServices.count(function(result) {
      configurations.usersCount = result.data;
    });

    itemServices.count(function(result) {
      configurations.itemsCount = result.data;
    });

    settingServices.getLastSync(function(result) {
      configurations.lastSyncDate = result.message;
    });

    itemGroupTechnicalSpecificationServices.getItemWithoutGroupTechnicalSpecification(
      function(result) {
        configurations.itemsNotConfiguredCount = result.data;
      }
    );
  },
  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      });
    }
  }
};
</script>
<style>
canvas {
  /*margin-top: 35px;*/
}
hr {
  border-color: rgba(0, 0, 0, 0);
}
.graphic-card {
  /* background: #ededed; */
  padding: 15px;
  border-radius: 5px;
  /*box-shadow:0px 0px 10px -5px rgba(0,0,0,0.3);*/
}
.graphic-title {
  position: absolute;
}
.graphic-title h6 {
  font-weight: bold;
}
.graphic-title h3 {
  font-size: 20px;
  font-weight: bold;
  color: #b5b5b5;
}
</style>
